import { render, staticRenderFns } from "./PositionSelect.vue?vue&type=template&id=131e1665&scoped=true&"
import script from "./PositionSelect.vue?vue&type=script&lang=js&"
export * from "./PositionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e1665",
  null
  
)

export default component.exports